import { render, staticRenderFns } from "./Taobao.vue?vue&type=template&id=39673270&scoped=true&"
import script from "./Taobao.vue?vue&type=script&lang=js&"
export * from "./Taobao.vue?vue&type=script&lang=js&"
import style0 from "./Taobao.vue?vue&type=style&index=0&id=39673270&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39673270",
  null
  
)

export default component.exports